module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cda-mobile-b66b860d6f772c5c46cd2fec1a8b974f.svg";